<template>
    <div>
        <label for="day">{{ orderType === 'deliver' ? 'Bezorgtijd' : 'Afhaaltijd' }}</label>
        <div class="form-row row">
            <div class="col-md-6 mb-2 mb-md-0"> 
                <select
                    @change="setSelectedDay($event)"
                    name="day"
                    id="day"
                    class="form-control"
                >
                    <option
                        v-for="day in days"
                        :key="day"
                        :value="day"
                    >
                        {{ day }}
                    </option>
                </select>
            </div>

            <div class="col-md-6">
                <select
                    name="ordered_for"
                    id="ordered_for"
                    class="form-control"
                >
                    <option
                        v-for="minute in minutes"
                        :key="minute"
                        :value="minute"
                    >
                        {{ minute | moment('H:mm') }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'CheckoutOrderedFor',
        data() {
            return {
                selectedDay: '',
            };
        },
        props: {
            orderOptions: {
                type: Object,
                required: true,
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.selectedDay = this.days[0];
            });
        },
        computed: {
            ...mapState({
                orderType: state => state.cart.orderType,
            }),

            days() {
                return Object.keys(this.orderOptions);
            },

            minutes() {
                return this.orderOptions[this.selectedDay];
            },
        },
        methods: {
            ...mapMutations('cart', [
                'setCheckoutDate',
            ]),

            setSelectedDay(event) {
                this.selectedDay = event.target.value;
            },
        },
        watch: {
            selectedDay() {
                this.setCheckoutDate(moment(Object.values(this.minutes)[0]));
            },
        },
    };
</script>

<style scoped>

</style>
